<template>
    <div></div>
</template>

<script>
    import Analytics from 'analytics'
    import googleAnalytics from '@analytics/google-analytics'
    import googleTagManager from '@analytics/google-tag-manager'

    export default {
        data: () => ({
            no_data: [null, '', undefined, 'null'],
            analytics: null,
            ready: false,
            unsubscribeInitializeAnalytics: null,
            unsubscribePageVisited: null,
            unsubscribeTriggerEvent: null
        }),
        mounted () {
            this.unsubscribeInitializeAnalytics = this.$store.subscribeAction(action => {
                if (action.type === 'vEmit' && action.payload.name === 'initializeAnalytics') {
                    this.initialize(action.payload.data)
                }
            })
            this.unsubscribePageVisited = this.$store.subscribeAction(action => {
                if (action.type === 'vEmit' && action.payload.name === 'pageVisited') {
                    this.registerVisit()
                }
            })
            this.unsubscribeTriggerEvent = this.$store.subscribeAction(action => {
                if (action.type === 'vEmit' && action.payload.name === 'triggerEvent') {
                    this.registerEvent(action.payload.data)
                }
            })
        },
        beforeDestroy () {
            this.unsubscribeInitializeAnalytics()
            this.unsubscribePageVisited()
            this.unsubscribeTriggerEvent()
        },
        methods: {
            initialize (options) {
                if (options) {
                    let plugins = []
                    if (!this.no_data.includes(options.ga_tracking_id)) {
                        plugins.push(googleAnalytics({measurementIds: [options.ga_tracking_id]}))
                    }
                    if (!this.no_data.includes(options.gtm_container_id)) {
                        plugins.push(googleTagManager({containerId: options.gtm_container_id}))
                    }
                    this.analytics = Analytics({
                        app: 'onboarding-form-app',
                        plugins
                    })
                    this.analytics.ready(() => {
                        this.ready = true
                    })
                }
            },
            registerVisit() {
                if(this.ready) {
                    this.analytics.page()
                }
            },
            registerEvent(e) {
                let event = e
                if (typeof event === 'string' && event.length > 40) {
                    event = event.slice(-40)
                }
                if(this.ready) {
                    this.analytics.track(event)
                }
            }
        }
    }
</script>
